import React from "react";
import { humanize } from "../../common/utils";
import { IMMUNIZATION_STATUS } from "../utils/immunizationStatus";

const ImmunizationStatusBadge = ({ immunizationStatus }) => {
  const status = IMMUNIZATION_STATUS[immunizationStatus] || IMMUNIZATION_STATUS.overdue;
  const styles = status.styles;

  const badgeStyles = {
    ...styles,
    color: styles.backgroundColor,
    backgroundColor: "white",
    borderRadius: "4px",
  };

  return (
    <div
      className="p-3 my-3"
      style={badgeStyles}
    >
      <div className="body-large-16-medium" style={{ color: badgeStyles.color }}>
        {humanize(immunizationStatus)}
      </div>
      <div className="body-medium-regular" style={{ color: badgeStyles.color }}>
        {status.subtext}
      </div>
    </div>
  );
};

export default ImmunizationStatusBadge;